// src/features/wf3/popup/W3JornadaIrregularModal.jsx
import React, { useEffect, useState } from "react";
import s from "./W3JornadaIrregularModal.module.css";

export default function W3JornadaIrregularModal({
  open,
  onClose,
  jornadaTotalHHMM,
  excessoHHMM,
  inicioJornada,
  previsaoEncerramento,
  previsaoIntervalo,
  tempoIntervalo,
  nomeAutorizador,
  onChangeNome,
  onConfirm,
}) {
  const [nome, setNome] = useState(nomeAutorizador || "");

  useEffect(() => {
    setNome(nomeAutorizador || "");
  }, [nomeAutorizador]);

  if (!open) return null;

  const handleConfirm = () => {
    const n = (nome || "").trim();
    if (!n) {
      alert("Informe o nome de quem autorizou a jornada irregular.");
      return;
    }
    onChangeNome?.(n);
    onConfirm?.(n);
  };

  return (
    <div className={s.backdrop} onClick={onClose}>
      <div
        className={`${s.modal} ${s.root}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Cabeçalho verde, alinhado com a ficha */}
        <div className={s.header}>
          <div className={s.title}>Jornada acima de 9 horas</div>
          <button className={s.close} aria-label="Fechar" onClick={onClose}>
            ×
          </button>
        </div>

        {/* Conteúdo principal */}
        <div className={s.content}>
          <p className={s.description}>
            A combinação de <strong>horário de início da jornada</strong> e{" "}
            <strong>previsão de encerramento da jornada</strong> está
            ultrapassando a carga horária máxima de 9h.
          </p>

          {/* Linha 1: início e encerramento */}
          <div className={`${s.grid} ${s.grid2} ${s.section}`}>
            <div className={s.field}>
              <span className={s.label}>Início da jornada</span>
              <div className={s.valueStrong}>{inicioJornada || "—"}</div>
            </div>
            <div className={s.field}>
              <span className={s.label}>Previsão de encerramento</span>
              <div className={s.valueStrong}>
                {previsaoEncerramento || "—"}
              </div>
            </div>
          </div>

          {/* Linha 2: previsão início intervalo + tempo intervalo */}
          <div className={`${s.grid} ${s.grid2} ${s.section}`}>
            <div className={s.field}>
              <span className={s.label}>Previsão de início do intervalo</span>
              <div className={s.valueStrong}>{previsaoIntervalo || "—"}</div>
            </div>
            <div className={s.field}>
              <span className={s.label}>Tempo de intervalo</span>
              <div className={s.valueStrong}>{tempoIntervalo || "—"}</div>
            </div>
          </div>

          {/* Jornada total prevista */}
          <div className={s.section}>
            <div className={s.field}>
              <span className={s.label}>Jornada total prevista</span>
              <div className={s.valueInline}>
                <span className={s.valueStrong}>
                  {jornadaTotalHHMM || "—"}
                </span>
                <span className={s.limitText}>(limite 09:00)</span>
              </div>
            </div>
          </div>

          {/* Excedente */}
          <div className={s.section}>
            <div className={s.field}>
              <span className={s.label}>Excedente previsto</span>
              <div className={s.valueExcedente}>{excessoHHMM || "—"}</div>
            </div>
          </div>

          {/* Nome do autorizador */}
          <div className={s.section}>
            <label className={s.field}>
              <span className={s.label}>
                Nome de quem autorizou a jornada irregular
              </span>
              <input
                className={s.input}
                type="text"
                value={nome}
                onChange={(e) => {
                  const value = e.target.value;
                  setNome(value);
                  onChangeNome?.(value);
                }}
                placeholder="Digite o nome completo"
              />
            </label>
          </div>
        </div>

        {/* Footer com botões padrão da ficha */}
        <div className={s.actions}>
          <span />
          <div className={s.actionsRight}>
            <button className={s.btn} onClick={onClose}>
              Cancelar
            </button>
            <button
              className={`${s.btn} ${s.btnPrimary}`}
              onClick={handleConfirm}
            >
              Confirmar aceite
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
